import { render, staticRenderFns } from "./top-header.vue?vue&type=template&id=6c6d1e08&scoped=true&"
import script from "./top-header.vue?vue&type=script&lang=js&"
export * from "./top-header.vue?vue&type=script&lang=js&"
import style0 from "./top-header.vue?vue&type=style&index=0&id=6c6d1e08&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6d1e08",
  null
  
)

export default component.exports